/* =========================================================
   MAGIC NEEDLES SEARCH V2
   Query → Destination Mapping

   MATCHING:
   - queries: exact match after lowercase/space normalization
   - contains: phrase can appear anywhere in the search

   IMPORTANT:
   - First matching block wins.
   - Keep more specific / higher-priority intent blocks first.
   - Use contains only for phrases that clearly indicate intent.
   ========================================================= */

window.MagicNeedlesSearchMap = [


  /* =========================================================
     YARN RECOMMENDATIONS BY PROJECT
     /pages/yarn-recommendations-by-project

     Any search containing "yarn for" is considered a
     project/use-case yarn recommendation query.
     ========================================================= */
  {
    queries: [
      "amigurumi yarn",
      "plushie yarn",
      "crochet toy yarn",
      "baby clothing yarn",
      "macrame yarn",
      "basket yarn",
      "bassinet yarn",
      "crochet coaster yarn",
      "table mat yarn",
      "placemat yarn",
      "table runner yarn",
      "curtain yarn",
      "bed cover yarn",
      "sofa cover yarn",
      "cushion cover yarn",
      "home decor yarn",
      "flower yarn",
      "crochet flower yarn",
      "glove yarn",
      "mitten yarn",
      "fingerless glove yarn",
      "leg warmer yarn",
      "bag yarn",
      "crochet bag yarn",
      "handbag yarn",
      "tote bag yarn",
      "sling bag yarn",
      "crochet belt yarn",
      "crochet jewellery yarn",
      "crochet jewelry yarn",
      "keychain yarn",
      "crochet keychain yarn",
      "scrunchie yarn",
      "crochet scrunchie yarn",
      "crochet lantern yarn",
      "mandala yarn",
      "crochet mandala yarn",
      "dreamcatcher yarn",
      "summer blanket yarn",
      "lightweight blanket yarn",
      "blanket yarn",
      "crochet blanket yarn",
      "knitting blanket yarn",
      "winter blanket yarn",
      "baby blanket yarn",
      "punch needle yarn",
      "punch needling yarn",
      "bandana yarn",
      "crochet bandana yarn",
      "head wrap yarn",
      "sun hat yarn",
      "crochet sun hat yarn",
      "crochet top yarn",
      "bralette yarn",
      "crochet bralette yarn",
      "crochet shirt yarn",
      "summer garment yarn",
      "sweater yarn",
      "crochet sweater yarn",
      "knitting sweater yarn",
      "cardigan yarn",
      "beanie yarn",
      "scarf yarn",
      "shawl yarn",
      "crochet shawl yarn",
      "knitting shawl yarn",
      "wrap yarn",
      "stole yarn",
      "baby yarn",
      "baby yarns",
      "baby wool",
      "baby clothing"
    ],

    contains: [
      "yarn for"
    ],

    label: "View our yarn recommendations",
    url: "/pages/yarn-recommendations-by-project"
  },

/* =========================================================
   LEGACY / COMPETITOR / ALTERNATIVE YARN SEARCHES
   ========================================================= */

/* GANGA DESIRE → ARAN SOLIDS */ 
    {
  contains: [
    "ganga desire"
  ],

  message: "A suitable alternative for makers searching for a similar yarn.",
  buttonLabel: "Aran Solids Yarn by Hobby Store",
  
  label: "Explore Aran Solids Yarn by Hobby Store",
  url: "/collections/hobby-store-aran-solids"
},

  
/* GANGA OLIVIA → DK SOLIDS */
{
  contains: [
    "ganga olivia"
  ],

  message: "A suitable alternative for makers searching for a similar yarn.",
  buttonLabel: "DK Solids Yarn by Hobby Store",

  label: "Explore DK Solids Yarn by Hobby Store",
  url: "/collections/hobby-store-dk-solids"
},


/* GANGA TAJ → MERINO WOOL */
{
  contains: [
    "ganga taj"
  ],

  message: "A suitable alternative for makers searching for a similar yarn.",
  buttonLabel: "Merino Wool Yarn by Hobby Store",

  label: "Explore Merino Wool Yarn by Hobby Store",
  url: "/collections/hobby-store-merino-wool"
},


/* ANCHOR → FINE MERCERISED COTTON */
{
  queries: [
    "anchor"
  ],

  contains: [
    "anchor yarn",
    "anchor cotton",
    "anchor thread"
  ],

  message: "A suitable alternative for makers searching for a similar yarn.",
  buttonLabel: "Fine Mercerised Cotton by Hobby Store",

  label: "Explore Fine Mercerised Cotton by Hobby Store",
  url: "/collections/hobby-store-fine-mercerised-cotton"
},


/* MILK / MILKY COTTON → ARAN ACRYCOT */
{
  contains: [
    "milk cotton",
    "milky cotton"
  ],

  label: "Explore Aran AcryCot Yarn by Hobby Store",
  url: "/collections/hobby-store-aran-acrycot"
},


/* GANGA ALISHA → ARAN SOLIDS */
{
  contains: [
    "ganga alisha"
  ],

  message: "A suitable alternative for makers searching for a similar yarn.",
  buttonLabel: "Aran Solids Yarn by Hobby Store",

  label: "Explore Aran Solids Yarn by Hobby Store",
  url: "/collections/hobby-store-aran-solids"
},


/* PLUSH / FLUFFY YARN → CHENILLE CAKE */
{
  queries: [
    "plush yarn",
    "fluffy yarn"
  ],

  contains: [
    "plush chenille yarn",
    "fluffy chenille yarn"
  ],

  label: "Explore Chenille Cake Yarn",
  url: "/collections/chenille-cake-yarn"
},


/* VARDHMAN / GANGA → YARN BRAND GUIDE */
{
  queries: [
    "vardhman",
    "vardhman yarn",
    "vardhman wool",
    "ganga",
    "ganga yarn",
    "ganga wool"
  ],

  label: "Explore yarn brands & alternatives",
  url: "/pages/yarns-by-brand-variants"
},

  /* =========================================================
     YARNS BY FIBRE / MATERIAL
     /pages/buy-yarn-by-fiber-type
     ========================================================= */
  {
    queries: [
      "cotton yarn",
      "acrylic yarn",
      "polyester yarn",
      "wool yarn",
      "merino yarn",
      "merino wool",
      "chenille yarn",
      "velvet yarn",
      "velvety yarn",
      "recycled yarn"
    ],

    label: "Explore yarns by fibre type",
    url: "/pages/buy-yarn-by-fiber-type"
  },


  /* =========================================================
     SHOP YARN BY WEIGHT / THICKNESS
     /pages/shop-yarn-by-weight
     ========================================================= */
  {
    queries: [
      "yarn by weight",
      "yarns by weight",
      "shop yarn by weight"
    ],

    contains: [
      "yarn weight",
      "yarn thickness",
      "weight 1 yarn",
      "weight 2 yarn",
      "weight 3 yarn",
      "weight 4 yarn",
      "weight 5 yarn",
      "weight 6 yarn",
      "weight 7 yarn",
      "super fine yarn",
      "superfine yarn",
      "fine weight yarn",
      "dk yarn",
      "double knitting yarn",
      "medium weight yarn",
      "aran yarn",
      "bulky yarn",
      "super bulky yarn",
      "jumbo yarn"
    ],

    label: "Explore yarns by thickness",
    url: "/pages/shop-yarn-by-weight"
  },


  /* =========================================================
     YARNS BY BRAND & VARIANT
     /pages/yarns-by-brand-variants
     ========================================================= */
  {
    queries: [
      "yarn by brand",
      "yarns by brand",
      "shop yarn by brand",
      "yarn variants",
      "yarn varieties"
    ],

    contains: [
      "yarn brand",
      "hobby store yarn",
      "kotton yarn",
      "magic needles yarn",
      "nako yarn"
    ],

    label: "Explore yarns by brand & variant",
    url: "/pages/yarns-by-brand-variants"
  },


  /* =========================================================
     CROCHET HOOKS
     /collections/crochet-hooks
     ========================================================= */
  {
    queries: [
      "crochet tools",
      "hooks for crochet"
    ],

    contains: [
      "crochet hook",
      "crochet needle",
      "tunisian crochet hook"
    ],

    label: "Explore crochet hooks",
    url: "/collections/crochet-hooks"
  },


  /* =========================================================
     KNITTING NEEDLES
     /collections/knitting-needles
     ========================================================= */
  {
    queries: [
      "knitting tools",
      "dpn",
      "dpns"
    ],

    contains: [
      "knitting needle",
      "circular needle",
      "cable needle",
      "double pointed needle"
    ],

    label: "Explore knitting needles",
    url: "/collections/knitting-needles"
  },


  /* =========================================================
     CROCHET & KNITTING KITS
     /collections/crochet-knitting-kits
     ========================================================= */
  {
    queries: [
      "crochet flower kit",
      "crochet bag kit",
      "crochet toy kit",
      "learn crochet kit",
      "learn knitting kit",
      "crochet project kit",
      "knitting project kit"
    ],

    contains: [
      "crochet kit",
      "knitting kit",
      "amigurumi kit"
    ],

    label: "Explore crochet & knitting kits",
    url: "/collections/crochet-knitting-kits"
  },


  /* =========================================================
     OFFLINE WORKSHOPS
     /collections/crochet-knitting-workshops
     ========================================================= */
  {
    queries: [
      "crochet toy workshop",
      "crochet flower workshop",
      "learn crochet mumbai",
      "learn crochet offline",
      "learn knitting mumbai"
    ],

    contains: [
      "crochet workshop",
      "crochet class",
      "knitting workshop",
      "knitting class",
      "amigurumi workshop",
      "amigurumi class"
    ],

    label: "Explore our workshops",
    url: "/collections/crochet-knitting-workshops"
  },


  /* =========================================================
     CROCHET & KNITTING PATTERNS
     /collections/patterns
     ========================================================= */
  {
    queries: [
      "crochet pdf pattern",
      "knitting pdf pattern",
      "crochet and knitting patterns",
      "digital crochet pattern",
      "digital knitting pattern"
    ],

    contains: [
      "crochet pattern",
      "knitting pattern"
    ],

    label: "Explore crochet & knitting patterns",
    url: "/collections/patterns"
  },


  /* =========================================================
     GUIDES & INSIGHTS
     /blogs/guide-more
     ========================================================= */
  {
    queries: [
      "learn about yarn",
      "understand yarn"
    ],

    contains: [
      "crochet guide",
      "knitting guide",
      "yarn guide",

      "crochet tips",
      "knitting tips",
      "yarn tips",

      "crochet information",
      "knitting information",
      "yarn information",

      "crochet blog",
      "knitting blog",
      "yarn blog",

      "crochet help",
      "knitting help",
      "yarn help",

      "crochet tutorial",
      "knitting tutorial",
      "yarn tutorial",

      "crochet resources",
      "knitting resources"
    ],

    label: "Explore our guides & insights",
    url: "/blogs/guide-more"
  },

/* =========================================================
     Sunflower Colors
     /blogs/guide-more
     ========================================================= */
  {
    queries: [
      "Sunflower Colors",
      "Sun flower Colors",
      "Sunflower Color",
      "Sun flower Color",
      "Sun flower yarn",
      "Sunflower yarn"
    ],

    label: "View our Sunflower Yarn Color Guide",
    url: "/blogs/guide-more/sunflower-colors-yarn-guide"
  },


  /* =========================================================
     FAQ
     /pages/faq

     Mostly exact-match because support terms can otherwise
     become too broad.
     ========================================================= */
  {
    queries: [
      "faq",
      "faqs",
      "frequently asked questions",
      "magic needles faq",
      "magic needles questions",

      "payment methods",
      "payment options",
      "how can i pay",
      "how to pay",
      "do you accept cod",
      "cod available",
      "cash on delivery",
      "is cod available",

      "discount code",
      "discount codes",
      "coupon code",
      "coupon codes",
      "promo code",
      "promo codes",

      "is magic needles safe",
      "is magic needles website safe",
      "is your website secure",

      "custom order",
      "custom orders",
      "custom size",
      "custom colour",
      "custom color",

      "out of stock order",
      "product out of stock",
      "what if product is out of stock"
    ],

    label: "View frequently asked questions",
    url: "/pages/faq"
  },


  /* =========================================================
     SHIPPING POLICY
     /policies/shipping-policy
     ========================================================= */
  {
    queries: [
      "shipping information",
      "delivery information",

      "how long is delivery",
      "how long does shipping take",
      "when will my order arrive",
      "when will my order be delivered",

      "dispatch time",
      "order dispatch time",
      "when will my order ship",
      "when will my order dispatch",

      "free shipping",
      "free delivery",

      "worldwide shipping",
      "do you ship internationally",
      "do you ship worldwide",

      "india shipping",
      "shipping in india",

      "india post",
      "courier partner",
      "delivery partner",

      "late delivery",
      "parcel not received",
      "shipment not received"
    ],

    contains: [
      "shipping policy",
      "delivery policy",
      "shipping time",
      "delivery time",

      "shipping charge",
      "shipping cost",
      "delivery charge",
      "delivery cost",

      "international shipping",
      "international delivery",

      "shipment delayed",
      "delivery delayed",

      "marked delivered not received",
      "delivered but not received"
    ],

    label: "View our shipping policy",
    url: "/policies/shipping-policy"
  },


  /* =========================================================
     RETURNS, REFUNDS & ORDER CHANGES
     /policies/refund-policy
     ========================================================= */
  {
    queries: [
      "refunds",
      "returns",
      "return and refund policy",
      "returns and refunds",

      "can i return",
      "how to return",
      "return an order",
      "return my order",

      "can i cancel my order",
      "cancel my order",
      "cancellation policy",

      "modify my order",
      "change my order",
      "order modification",
      "order changes",

      "wrong address",
      "incorrect address",
      "update address",

      "received damaged product",

      "incorrect product",
      "incorrect item",

      "rto",
      "refused delivery",
      "refuse delivery",

      "refund as store credit"
    ],

    contains: [
      "refund policy",
      "return policy",

      "cancel order",
      "order cancellation",

      "modify order",
      "change order",

      "change address",
      "change delivery address",

      "damaged order",
      "damaged parcel",
      "damaged product",

      "wrong product",
      "wrong item",

      "missing item",
      "missing product",

      "unpacking video",
      "unboxing video",

      "return to origin",
      "store credit refund"
    ],

    label: "View our return & refund policy",
    url: "/policies/refund-policy"
  },


  /* =========================================================
     CONTACT US
     /pages/contact
     ========================================================= */
  {
    queries: [
      "contact",
      "contact us",
      "magic needles contact",
      "customer care",
      "customer support",
      "whatsapp number",
      "customer care email",
      "magic needles number",
      "call",
      "contact number",
      "complaint",
      "customer complaint",
      "need help"
    ],

    contains: [
      "contact magic needles",
      "magic needles customer care",
      "magic needles support",
      "magic needles whatsapp",
      "whatsapp magic needles",
      "magic needles email",
      "email magic needles",
      "magic needles phone number"
    ],

    label: "Contact Magic Needles",
    url: "/pages/contact"
  },


  /* =========================================================
     MUMBAI RETAIL STORE
     /pages/yarn-store-mumbai
     ========================================================= */
  {
    queries: [
      "physical yarn store",
      "retail yarn store",
      "visit magic needles",
      "store location",
      "store address",
      "magic needles address"
    ],

    contains: [
      "magic needles store",
      "magic needles shop",
      "magic needles retail store",
      "magic needles physical store",
      "magic needles mumbai",
      "magic needles vikhroli",
      "yarn store mumbai",
      "yarn shop mumbai",
      "wool shop mumbai",
      "crochet shop mumbai",
      "knitting shop mumbai",
      "knitting store mumbai",
      "crochet store mumbai",
      "yarn shop vikhroli",
      "yarn store vikhroli"
    ],

    label: "Visit our Mumbai yarn store",
    url: "/pages/yarn-store-mumbai"
  },


  /* =========================================================
     NEW ARRIVALS
     /pages/new-arrivals
     ========================================================= */
  {
    queries: [
      "new arrivals",
      "new products",
      "new launches",
      "latest products",
      "latest arrivals",
      "what's new",
      "whats new"
    ],

    contains: [
      "new yarn",
      "latest yarn",
      "new crochet products",
      "new knitting products"
    ],

    label: "Explore what's new",
    url: "/pages/new-arrivals"
  },


  /* =========================================================
     CLEARANCE
     /collections/clearance-zone
     ========================================================= */
  {
    queries: [
      "discounted yarn",
      "discount yarn",
      "yarn sale",
      "sale products",
      "products on sale"
    ],

    contains: [
      "clearance"
    ],

    label: "Explore clearance deals",
    url: "/collections/clearance-zone"
  },


  /* =========================================================
     E-GIFT CARD
     /products/e-gift-card
     ========================================================= */
  {
    contains: [
      "gift card",
      "gift voucher"
    ],

    label: "Explore our E-Gift Card",
    url: "/products/e-gift-card"
  },


  /* =========================================================
     OUR STORY
     /pages/our-story
     ========================================================= */
  {
    queries: [
      "our story",
      "about us",
      "who is magic needles",
      "who are magic needles",
      "magic needles company",
      "magic needles brand",
      "where is magic needles from",
      "magic needles made in india"
    ],

    contains: [
      "about magic needles",
      "magic needles story"
    ],

    label: "Discover the Magic Needles story",
    url: "/pages/our-story"
  },


  /* =========================================================
     HANDMADE APPAREL
     /collections/handmade-apparel
     ========================================================= */
  {
    contains: [
      "handmade apparel",
      "handmade clothing",
      "handmade clothes",
      "crochet apparel",
      "knitted apparel",
      "crochet clothing",
      "knitted clothing"
    ],

    label: "Explore handmade apparel",
    url: "/collections/handmade-apparel"
  },


  /* =========================================================
     HANDMADE HOME DECOR
     /collections/handmade-home-decor
     ========================================================= */
  {
    contains: [
      "handmade home decor",
      "crochet home decor",
      "knitted home decor",
      "handmade decor",
      "crochet decor",
      "knitted decor",
      "handmade home decoration",
      "crochet home decoration"
    ],

    label: "Explore handmade home décor",
    url: "/collections/handmade-home-decor"
  },

];